import { EquipmentModel, initialEquipmentModel } from './equipment.interface';

export interface OdataEquipmentsModel {
    User: string;
    Material: string;
    SerialNo: string;
    OrderNo: string;
    EquipmentsSet: { results: EquipmentModel[] };
}

export const initialOdataEquipmentModel: OdataEquipmentsModel = {
    User: '',
    Material: '',
    SerialNo: '',
    OrderNo: '',
    EquipmentsSet: {
        results: [initialEquipmentModel],
    },
};
